// extracted by mini-css-extract-plugin
export default {"forPointers":"Units_forPointers__EO6bd"};